// copied from calling-widget-ui/userSettings/constants/UserSettingsDefaultValues
import { USER_SETTINGS_KEYS } from './UserSettingsKeys';
import { THREE_BUSINESS_DAYS } from './RelativeDates';
export const NO_REMINDER = 'noReminder';
const EIGHT_HOURS_IN_MINUTES = 8 * 60;
export const FetchUserSettingsDefaultValues = USER_SETTINGS_KEYS.reduce((acc, key, i) => {
  return Object.assign({}, acc, {
    [key]: [JSON.stringify(THREE_BUSINESS_DAYS), JSON.stringify(EIGHT_HOURS_IN_MINUTES), JSON.stringify(NO_REMINDER)][i]
  });
}, {});